import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter: React.FC = () => {
  return (
    <footer className="border-t border-light-gray bg-white mt-10">
      <div className="px-4 sm:px-6 lg:px-8 py-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <img src="/logo.png" alt="" className="w-6 h-6 rounded" aria-hidden />
            <div className="leading-tight">
              <div>
                © {new Date().getFullYear()}{' '}
                <span className="font-semibold text-charcoal">Suitcase Muse</span>. All rights reserved.
              </div>
              <div className="text-xs text-gray-400 mt-0.5">
                A brand of Muse Globaltech Ventures Private Limited
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm">
            <Link to="/shipping" className="text-gray-500 hover:text-coral transition-colors">
              Shipping
            </Link>
            <Link to="/returns" className="text-gray-500 hover:text-coral transition-colors">
              Refunds
            </Link>
            <Link to="/privacy" className="text-gray-500 hover:text-coral transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-coral transition-colors">
              Terms
            </Link>
            <Link to="/contact" className="text-gray-500 hover:text-coral transition-colors">
              Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
